import { useState, useEffect } from "react";
import NiceModal, { useModal, bootstrapDialog } from "@ebay/nice-modal-react";
import BootstrapModal from "react-bootstrap/Modal";
import { useForm, Controller } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import React from "react";
import { toast } from "react-toastify";
import { instance } from "../axios";
import { useNavigate, useParams } from "react-router-dom";
import { UiSelect, UiDatePicker, UiRSelect, UiToggle, titleCase, BgLoader } from "../ui";
import Button from 'react-bootstrap/Button';
import Form from 'react-bootstrap/Form';
import { useStore } from "../state.js";
import ImageUploader from "../components/ImageUploader";
import SortableImageGrid from "../components/SortableImageGrid";

const AddContact = NiceModal.create(
  ({ id, subtitle, action, bgColor, note = "", defaultImages = [] }) => {
    const [input, setInput] = useState(note);
    const [state, setState] = useState({ count: 0 });
    const [entry, setEntry] = useState([]);
    const modal = useModal();
    const zstate = useStore((state) => state.groups);
    const mstate = useStore((state) => state.machines);
    const settingState = useStore((state) => state.settings);

    const [images, setImages] = useState(
      defaultImages.map(img => ({
        id: img.id,
        url: img.url
      }))
    );

    const [deleted, setDeleted] = useState([]);

    const setZState = useStore((state) => state.setGroups);
    const schema = yup.object().shape({
      name: yup.string().required("Enter name"),
      mobile: yup.string().nullable().when('mobile', {
        is: (value) => value?.length,
        then: (rule) => rule.matches(/^[0-9]+$/, "Enter 10 digit mobile number")
          .min(10, "Enter 10 digit mobile number")
          .max(10, "Enter 10 digit mobile number"),
      }),

      mobile2: yup.string().nullable().when('mobile2', {
        is: (value) => value?.length,
        then: (rule) => rule.matches(/^[0-9]+$/, "Enter 10 digit mobile number")
          .min(10, "Enter 10 digit mobile number")
          .max(10, "Enter 10 digit mobile number"),
      }),

      machine: yup.array().of(
        yup.object().shape({
          name: yup.string().required("Required"),
          qty: yup.string().required("Required")
        })
      ),
      groups: yup.array().min(1, 'Select group').required('Select group'),

    }, [["mobile2", "mobile2"], ["mobile", "mobile"]]);
    const {
      register,
      handleSubmit,
      control,
      unregister,
      setValue,
      formState: { errors },
      reset,
    } = useForm({
      resolver: yupResolver(schema),
    });
    const onSubmitHandler = async (data) => {
      SaveTag(data);
      //reset();
    };
    var SaveTag = (e) => {
      e = {
        ...e,
        images: images.map((img, index) => ({
          id: img.id,
          order: index
        })),
        deleted
      };
      setState({ ...state, loader: true });

      instance({
        method: "post",
        url: "/update_contact.php",
        data: e,
        headers: { "Content-Type": "application/json" },
      })
        .then(function (response) {
          setState({ ...state, loader: false });
          if (response.data.status == "error") {
            toast(response.data.msg, { type: "error" });
          }
          if (response.data.status == "success") {
            toast(response.data.msg, { type: "success" });
            modal.resolve({ resolved: true });
            modal.hide();
          }
        })
        .catch(function (response) { });
    };
    useEffect(() => {
      fetchData();

      //setEntry(data.machines)
      // setState({ ...state, count: data.machines.length })



    }, []);


    let navigate = useNavigate();

    const handleHide = () => {
      modal.hide();
    }

    const insertEntry = () => {
      setState({ ...state, count: state.count + 1 })
      setEntry([...entry, { id: state.count }])


    }


    const fetchData = () => {

      instance
        .get("/get_contact.php?id=" + id)
        .then(function (response) {

          setState({ ...response.data, count: response.data.item.machines ? response.data.item.machines.length : 0 });
          setEntry(response.data.item.machines)
          reset(response.data.item);

          if (response.data.images) {

            setImages(response.data.images.map(img => ({id: img.id,url: img.url})));

          }

        })
        .catch(function () { });

    };



    const deleteEntry = (id, idx) => {
      var aa = entry;
      unregister(`machine.[${idx}].name`);
      unregister(`machine.[${idx}].name`);
      unregister(`machine.[${idx}]`);
      var filtered = aa.filter(function (value, index, arr) {
        return value.id !== id;
      });
      console.log(filtered)
      setEntry(filtered);
    }


    return (
      <BootstrapModal size="lg" {...bootstrapDialog(modal)} onHide={() => handleHide()}>
        <BootstrapModal.Header closeButton>
          <BootstrapModal.Title>Add Contact</BootstrapModal.Title>
        </BootstrapModal.Header>

        <BootstrapModal.Body>
          {state.status ? (
            <>
              <form id="contactform" onSubmit={handleSubmit(onSubmitHandler)}>
                <div className="row">

                  <div className="col-md-8">
                    <Form.Group className="mb-3" >
                      <Form.Label>Name</Form.Label>
                      <Form.Control type="text" name="name"   {...register("name", { onBlur: (e) => setValue('name', titleCase(e.target.value)) })} />
                      <Form.Text className="text-danger">
                        {errors.name?.message}
                      </Form.Text>
                    </Form.Group>
                  </div>
                  <div className="col-md-4">
                    <Controller
                      name="groups[]"
                      control={control}
                      render={({ field }) => (

                        <UiRSelect
                          {...field}
                          options={zstate}
                          className="ss"
                          isMulti
                          message={errors.groups?.message}
                          label="Group"
                        />

                      )}
                    />
                  </div>
                </div>


                <div className="row">

                  <div className="col-6">
                    <UiToggle id="active" name="is_active" title="Business Active" {...register("is_active")} />
                  </div>
                  <div className="col-6">
                    <UiToggle id="send_msg" name="send_msg" title="Send Message" {...register("send_msg")} />
                  </div>
                </div>


                <div className="row">
                  <div className="col-md-3">
                    <Form.Group className="mb-3" >
                      <Form.Label>Contact Person 1</Form.Label>
                      <Form.Control type="text" name="name1" {...register("name1", { onBlur: (e) => setValue('name1', titleCase(e.target.value)) })} />
                      <Form.Text className="text-danger">
                        {errors.name1?.message}
                      </Form.Text>
                    </Form.Group>
                  </div>
                  <div className="col-md-3">
                    <Form.Group className="mb-3" >
                      <Form.Label>Mobile No. 1</Form.Label>
                      <Form.Control type="number" name="mobile"  {...register("mobile")} />
                      <Form.Text className="text-danger">
                        {errors.mobile?.message}
                      </Form.Text>
                    </Form.Group>
                  </div>
                  <div className="col-md-3">
                    <Controller
                      name="dob"
                      control={control}
                      render={({
                        field: { onChange, onBlur, value, name, ref },
                        fieldState: { invalid, isTouched, isDirty, error },
                        formState,
                      }) => (
                        <UiDatePicker
                          label="Date of Birth 1"
                          onChange={onChange}
                          default_val={value}
                          message={errors.dob?.message}
                          dateFormat="dd-MM-yyyy"
                          ref={ref}
                          name={name}
                        />
                      )}
                    />
                  </div>
                  <div className="col-md-3">
                    <Controller
                      name="wedding"
                      control={control}
                      render={({
                        field: { onChange, onBlur, value, name, ref },
                        fieldState: { invalid, isTouched, isDirty, error },
                        formState,
                      }) => (
                        <UiDatePicker
                          label="Wedding anniversary 1"
                          onChange={onChange}
                          default_val={value}
                          message={errors.wedding?.message}
                          dateFormat="dd-MM-yyyy"
                          ref={ref}
                          name={name}
                        />
                      )}
                    />
                  </div>
                </div>



                <div className="row">
                  <div className="col-md-3">
                    <Form.Group className="mb-3" >
                      <Form.Label>Contact Person 2</Form.Label>
                      <Form.Control type="text" name="name2"  {...register("name2", { onBlur: (e) => setValue('name2', titleCase(e.target.value)) })} />
                      <Form.Text className="text-danger">
                        {errors.name2?.message}
                      </Form.Text>
                    </Form.Group>
                  </div>
                  <div className="col-md-3">
                    <Form.Group className="mb-3" >
                      <Form.Label>Mobile No. 2</Form.Label>
                      <Form.Control type="number" name="mobile2"  {...register("mobile2")} />
                      <Form.Text className="text-danger">
                        {errors.mobile2?.message}
                      </Form.Text>
                    </Form.Group>
                  </div>
                  <div className="col-md-3">
                    <Controller
                      name="dob2"
                      control={control}
                      render={({
                        field: { onChange, onBlur, value, name, ref },
                        fieldState: { invalid, isTouched, isDirty, error },
                        formState,
                      }) => (
                        <UiDatePicker
                          label="Date of Birth 2"
                          onChange={onChange}
                          default_val={value}
                          message={errors.dob2?.message}
                          dateFormat="dd-MM-yyyy"
                          ref={ref}
                          name={name}
                        />
                      )}
                    />
                  </div>
                  <div className="col-md-3">
                    <Controller
                      name="wedding2"
                      control={control}
                      render={({
                        field: { onChange, onBlur, value, name, ref },
                        fieldState: { invalid, isTouched, isDirty, error },
                        formState,
                      }) => (
                        <UiDatePicker
                          label="Wedding anniversary 2"
                          onChange={onChange}
                          default_val={value}
                          message={errors.wedding2?.message}
                          dateFormat="dd-MM-yyyy"
                          ref={ref}
                          name={name}
                        />
                      )}
                    />
                  </div>
                </div>



                <div className="row">
                  <div className="col-md-6">
                    <Form.Group className="mb-3" >
                      <Form.Label>City</Form.Label>
                      <Form.Control type="text" name="city"  {...register("city")} />
                      <Form.Text className="text-danger">
                        {errors.city?.message}
                      </Form.Text>
                    </Form.Group>
                  </div>
                  <div className="col-md-6">
                    <Form.Group className="mb-3" >
                      <Form.Label>Address</Form.Label>
                      <Form.Control type="text" name="address"  {...register("address")} />
                      <Form.Text className="text-danger">
                        {errors.address?.message}
                      </Form.Text>
                    </Form.Group>
                  </div>
                </div>











                <b>Machines</b>
                <div className="border rounded p-3 mb-3">
                  {entry && entry.length > 0 && entry.map((value, i) => (
                    <div key={i} className="d-flex mb-2">
                      <div key={i} className="flex-grow-1">
                        <UiSelect
                          name={`machine[${i}].name`}
                          message={errors.machine?.[i]?.name?.message}
                          defaultValue={value.machine}
                          options={mstate}
                          {...register(`machine.[${i}].name`)}
                        />
                      </div>
                      <div className="ps-3 col-3"><Form.Control
                        placeholder="Qty"
                        type="number"
                        className="mb-0"
                        name={`machine[${i}].qty`}

                        defaultValue={value.qty}
                        {...register(`machine.[${i}].qty`)}
                      />
                        <Form.Text className="text-danger">
                          {errors.machine?.[i]?.qty?.message}
                        </Form.Text>
                      </div>
                      <button className="btn btn-outline-danger ms-3" style={{ height: "34px" }} onClick={() => deleteEntry(value.id, i)} >Delete</button>
                    </div>
                  ))}

                  <div className="text-center">
                    <div className="btn btn-secondary" onClick={() => insertEntry()} ><span className="sicon">+</span> Add</div>
                  </div>
                </div>

                <div className="row">
                  <div className="col-md-4">
                    <Form.Group className="mb-3" >
                      <Form.Label>Email</Form.Label>
                      <Form.Control type="text" name="email" {...register("email")} />
                      <Form.Text className="text-danger">
                        {errors.email?.message}
                      </Form.Text>
                    </Form.Group>
                    <UiToggle id="a1" name="hide_email" title="Hide on Website" {...register("hide_email")} />
                  </div>

                  <div className="col-md-4">
                    <Form.Group className="mb-3" >
                      <Form.Label>Website</Form.Label>
                      <Form.Control type="text" name="website" {...register("website")} />
                      <Form.Text className="text-danger">
                        {errors.website?.message}
                      </Form.Text>
                    </Form.Group>
                    <UiToggle id="a2" name="hide_website" title="Hide on Website" {...register("hide_website")} />
                  </div>

                  <div className="col-md-4">
                    <Form.Group className="mb-3" >
                      <Form.Label>Google Map Link</Form.Label>
                      <Form.Control type="text" name="google_map_link" {...register("google_map_link")} />
                      <Form.Text className="text-danger">
                        {errors.google_map_link?.message}
                      </Form.Text>
                    </Form.Group>
                    <UiToggle id="a3" name="hide_google_map_link" title="Hide on Website" {...register("hide_google_map_link")} />
                  </div>
                </div>


                <div className="row">
                  <div className="col-md-3">
                    <UiSelect
                      label="Caste"
                      name={`caste`}
                      message={errors.caste?.message}
                      options={settingState.caste}
                      {...register(`caste`)}
                    />
                    <UiToggle id="a1" name="hide_caste" title="Hide on Website" {...register("hide_caste")} />
                  </div>
                  <div className="col-md-3">
                    <UiSelect
                      label="Area"
                      name={`area`}
                      message={errors.area?.message}
                      options={settingState.area}
                      {...register(`area`)}
                    />
                    <UiToggle id="a1" name="hide_area" title="Hide on Website" {...register("hide_area")} />
                  </div>
                  <div className="col-md-3">
                    <UiSelect
                      label="District"
                      name={`district`}
                      message={errors.district?.message}
                      options={settingState.district}
                      {...register(`district`)}
                    />
                    <UiToggle id="a2" name="hide_district" title="Hide on Website" {...register("hide_district")} />
                  </div>
                  <div className="col-md-3">
                    <UiSelect
                      label="State"
                      name={`state`}
                      message={errors.state?.message}
                      options={settingState.state}
                      {...register(`state`)}
                    />
                    <UiToggle id="a3" name="hide_state" title="Hide on Website" {...register("hide_state")} />
                  </div>


                </div>


                <div className="row">
                  <div className="col-md-4">
                    <Form.Group className="mb-3" >
                      <Form.Label>GST Number</Form.Label>
                      <Form.Control type="text" name="gst_number" {...register("gst_number", { onBlur: (e) => setValue('gst_number', titleCase(e.target.value)) })} />
                      <Form.Text className="text-danger">
                        {errors.gst_number?.message}
                      </Form.Text>
                    </Form.Group>
                    <UiToggle id="a1" name="hide_gst_number" title="Hide on Website" {...register("hide_gst_number")} />
                  </div>
                  <div className="col-md-4">
                    <Form.Group className="mb-3" >
                      <Form.Label>Establishment Year</Form.Label>
                      <Form.Control type="text" name="establishment_year" {...register("establishment_year", { onBlur: (e) => setValue('establishment_year', titleCase(e.target.value)) })} />
                      <Form.Text className="text-danger">
                        {errors.establishment_year?.message}
                      </Form.Text>
                    </Form.Group>
                    <UiToggle id="a2" name="hide_establishment_year" title="Hide on Website" {...register("hide_establishment_year")} />
                  </div>
                  <div className="col-md-4">
                    <UiSelect
                      label="Ownership Type"
                      name={`ownership_type`}
                      message={errors.ownership_type?.message}
                      options={settingState.ownership_type}
                      {...register(`ownership_type`)}
                    />
                    <UiToggle id="a3" name="hide_ownership_type" title="Hide on Website" {...register("hide_ownership_type")} />
                  </div>


                </div>



                <div className="row">
                  <div className="col-md-4">
                    <Form.Group className="mb-3" >
                      <Form.Label>Monthly Production Capacity</Form.Label>
                      <Form.Control type="text" name="monthly_production_capacity" {...register("monthly_production_capacity", { onBlur: (e) => setValue('monthly_production_capacity', titleCase(e.target.value)) })} />
                      <Form.Text className="text-danger">
                        {errors.monthly_production_capacity?.message}
                      </Form.Text>
                    </Form.Group>
                    <UiToggle id="a2" name="hide_monthly_production_capacity" title="Hide on Website" {...register("hide_monthly_production_capacity")} />
                  </div>
                  <div className="col-md-4">
                    <UiSelect
                      label="Business Category"
                      name={`business_category`}
                      message={errors.business_category?.message}
                      options={settingState.category}
                      {...register(`business_category`)}
                    />
                    <UiToggle id="a1" name="hide_business_category" title="Hide on Website" {...register("hide_business_category")} />
                  </div>
                  <div className="col-md-4">
                    <UiSelect
                      label="Business Type"
                      name={`business_type`}
                      message={errors.business_type?.message}
                      options={settingState.business_type}
                      {...register(`business_type`)}
                    />
                    <UiToggle id="a1" name="hide_business_type" title="Hide on Website" {...register("hide_business_type")} />
                  </div>
                </div>

                <Controller
                  name="colors[]"
                  control={control}
                  render={({ field }) => (

                    <UiRSelect
                      {...field}
                      options={settingState.colors}
                      className="ss"
                      isMulti
                      message={errors.colors?.message}
                      label="Colors"
                    />

                  )}
                />

                <div className="mt-4">

                  <label className="form-label">Images</label>

                  <ImageUploader
                    onUploaded={(img) =>
                      setImages(prev => [...prev, img])
                    }
                  />

                  <SortableImageGrid
                    images={images}
                    setImages={setImages}
                    onDelete={(img) => {
                      console.log(img);
                      setDeleted(prev => [...prev, img.id]);

                      setImages(prev =>
                        prev.filter(i => i.id !== img.id)
                      );

                    }}
                  />

                </div>
                {id && (<input type="hidden" value={id} name="id" {...register("id")} />)}
                <Button variant="primary" type="submit">
                  Submit
                </Button>
              </form>
              <p className="mt-2">Created by: {state.item.created_by} | Created On: {state.item.created_on}</p>
            </>
          ) : (

            <BgLoader />

          )}

        </BootstrapModal.Body>

      </BootstrapModal>
    );
  }
);

export default AddContact;
